import 'intersection-observer';
import Vue from 'vue';
import Resource from 'vue-resource';
import { i18n } from './tools/i18n';
import App from './components/App.vue';
import router from './router';
import store from './store';
import { logger } from './tools/logger';
import './assets/dayjsLocales';
import { version } from '../package.json';

logger.log(`%c shoutr.labs Webclient ${version}`, 'text-align: center; font-size: 40px;');

import registerGlobalComponents from './tools/registerGlobalComponents';

// import './registerServiceWorker';

Vue.config.ignoredElements = [
	'system',
	'player',
	'modal',
	'media-3d',
	'media-ar',
	'media-image',
	'media-audio',
	'media-video',
	'media-gallery',
	'question-inputtext',
	'answer-inputtext',
	'answer-multiplechoice',
	'question-multiplechoice',
	'answer-singlechoice',
	'question-singlechoice',
	'question-rating',
	'answer-rating',
	'teaser',
	'question-textarea',
	'answer-textarea',
	'button',
	'text-post',
	'text-element',
	'setting',
];

Vue.config.productionTip = false;
Vue.use(Resource);

// Define global components that can be used without importing them.
registerGlobalComponents();

window.$vueInstances = new Vue({
	el: '#app',
	i18n,
	router,
	store,
	render: h => h(App),
});

(async () => {
	const module = await import(
		/* webpackChunkName: "tools/developmentHelpers" */ './tools/developmentHelpers'
	);
	module.init();
})();
